<template>
  <div>
    <h2>
      <el-button class="pull-right" v-if="canAdd()" @click="showDialog()" type="primary">Nuevo</el-button>
      Planillas
    </h2>
    <app-table
      @change-pagination="onChangePagination"
      @change-search="onChangeSearch"
      :total="total">

      <el-table
        v-loading="loading"
        :data="tableData"
        style="width: 100%">
        <el-table-column
          prop="name"
          label="Nombre">
        </el-table-column>
        <el-table-column
          prop="name"
          label="Compañia">
          <template slot-scope="scope">
            {{ scope.row.company.name }}
          </template>
        </el-table-column>
        <el-table-column
          prop="type"
          label="Tipo">
        </el-table-column>
        <el-table-column
          width="100">
          <template slot-scope="scope">
            <el-button
              v-if="canUpdate()"
              size="mini"
              type="warning"
              @click="showDialog(scope.row)">
              <i class="el-icon-edit"></i>
            </el-button>
            <el-button
              v-if="!canUpdate() && canShow()"
              size="mini"
              type="primary"
              @click="showDialog(scope.row)">
              <i class="fa fa-eye"></i>
            </el-button>
            <el-button
              v-if="canDelete()"
              type="danger"
              size="mini"
              @click="handleDelete(scope.$index, scope.row)">
              <i class="el-icon-delete"></i>
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </app-table>

    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible">
      <el-tabs  v-model="activeName" >
        <el-tab-pane label="Planilla" name="first">
          <el-form ref="form" :model="form" :rules="rules" label-position="top">
            <el-form-item label="Nombre" prop="name">
              <el-input v-model="form.name" :disabled="canEditToSave()"></el-input>
            </el-form-item>
            <el-form-item label="Compañía" prop="company_id">
              <el-select v-model="form.company_id"
                         :disabled="canEditToSave()"
                         clearable
                         placeholder="Seleccionar"
                         style="width: 100%">
                <el-option
                  v-for="item in companies"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="Tipo" prop="type">
              <el-select v-model="form.type"
                         :disabled="canEditToSave()"
                         clearable
                         placeholder="Seleccionar"
                         style="width: 100%">
                <el-option
                  v-for="item in types_d"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="Dia de pago" prop="pay_day" >
              <el-input-number v-model="form.pay_day" :disabled="canEditToSave()" controls-position="right"></el-input-number>
            </el-form-item>
            <el-form-item label="Dia de pago semanal" prop="weekly_payday" >
              <el-input-number v-model="form.weekly_payday" :disabled="canEditToSave()" controls-position="right"></el-input-number>
            </el-form-item>
          </el-form>
          <div  class="dialog-footer float-right">
            <el-button @click="dialogVisible = false">Cancelar</el-button>
            <el-button type="primary" :loading="processing" v-if="!canEditToSave()" @click="save()">Guardar</el-button>
          </div>
          <div role="alert" v-if="error.message" class="el-alert el-alert--error">
            <div class="el-alert__content">
              <span class="el-alert__title is-bold">{{ error.message }}</span>
              <p class="el-alert__description">
              <ul>
                <li v-for="item in error.errors">{{ item[0] }}</li>
              </ul>
              </p>
            </div>
          </div>
          <el-alert
            v-if="success"
            title="Se ha guardado exitosamente."
            type="success">
          </el-alert>
        </el-tab-pane>
        <el-tab-pane label="Deducibles" name="second" v-if="form.id">
          <deductibles-table :payroll_id ="form.id" :company_id="form.company_id">
          </deductibles-table>
        </el-tab-pane>
        <el-tab-pane label="Provisiones" name="third" v-if="form.id">
          <provisions-table :payroll_id ="form.id" :company_id="form.company_id">
          </provisions-table>
        </el-tab-pane>
      </el-tabs>
    </el-dialog>

  </div>
</template>

<script>
  import AppTable from '../../components/Table'
  import BaseCrud from '../../components/abstract/BaseCrud'
  import {baseApi} from '../../configs/urls'
  import DeductiblesTable from './DeductiblesTable.vue'
  import ProvisionsTable from './ProvisionsTable.vue'

  export default {
    name: 'cost-center-list',
    extends: BaseCrud,
    components: {
      AppTable, DeductiblesTable, ProvisionsTable
    },
    data () {
      return {
        baseUrl: baseApi + '/payrolls',
        companies: [],
        activeName: 'first',
        types_d: [{
          value: 'Semanal',
          label: 'Semanal'
        }, {
          value: 'Quincena',
          label: 'Quincena'
        }, {
          value: 'Mensual',
          label: 'Mensual'
        }],
        basePermission: 'payrolls',
        form: {
          name: '',
          company_id: '',
          type: '',
          pay_day: 1,
          weekly_payday: 1
        },
        rules: {
          name: [
            { required: true, message: 'El nombre es requerido', trigger: 'blur' }
          ],
          type: [
            { required: true, message: 'El tipo es requerido', trigger: 'blur' }
          ],
          company_id: [
            { required: true, message: 'La compañia es requerida', trigger: 'change' }
          ]
        }
      }
    },
    methods: {
      _formatModel (model) {
        model.company_id = model.company_id.toString()
      }
    },
    mounted () {
      this.$http.get(baseApi + '/companies')
        .then(
          (res) => {
            this.companies = res.body.map((item) => {
              item.id = item.id.toString()
              return item
            })
          }
        )
    }
  }
</script>
<style>
  .float-right{
    float: right;
  }
  .text-center{
    text-align: center;
    vertical-align: middle;
  }
</style>



// WEBPACK FOOTER //
// src/views/payrolls/Payrolls.vue